export const styles = (theme) => ({
  '& .MuiFormLabel-asterisk': {
    color: 'error.D10',
  },
  '& .MuiOutlinedInput-notchedOutline legend': {
    maxWidth: 'unset',
    ...theme.typography.label2,
    '> span': {
      p: '0 3px',
    },
  },
  '& .MuiAutocomplete-popupIndicatorOpen': {
    transform: 'rotate(180)',
  },
  '& .MuiAutocomplete-endAdornment': {
    paddingRight: '3px',
  },
  '& .MuiInputAdornment-root': {
    mr: 1,
    ml: 1,
  },
});
